import React from "react";
import { useAuth } from "../../hooks/AuthContext";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";

const SearchCategoryList = ({ setIsDropdownOpen }) => {
  const { categoryList, user } = useAuth();
  const navigate = useNavigate();
  const handleClick = (category) => {
    navigate(`/listing/${category?.category_slug}`);
    setIsDropdownOpen(false);
  };
  return (
    categoryList?.length > 0 && (
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: 2,
          overflowX: "auto",
          pb: 1,
        }}
      >
        {categoryList.map((category) => (
          <Box
            onClick={() => handleClick(category)}
            key={category.id}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              p: 1,
            }}
          >
            <Box
              sx={{
                width: { xs: 60, md: 80 },
                height: { xs: 60, md: 80 },
                borderRadius: "50%",
                overflow: "hidden",
                mb: 1,
                backgroundImage: `url(${category?.app_category_image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <Typography
              variant="caption"
              align="center"
              sx={{
                fontSize: { xs: "11px", md: "12px" },
                fontWeight: 600,
                color: "var(--neutral-800)",
                lineHeight: "167%",
              }}
            >
              {category?.category_name}
            </Typography>
          </Box>
        ))}
      </Box>
    )
  );
};

export default SearchCategoryList;
